import script from "./CompanyStructure.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyStructure.vue?vue&type=script&setup=true&lang=js"

import "./CompanyStructure.vue?vue&type=style&index=0&id=05e8b218&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e8b218"]])

export default __exports__